import unauthBase from 'unauth_base';
import 'es6-promise/auto';

Promise.all([
    import('cookie-helper'),
    import('url-helper'),
]).then((deps) => {
    let [cookie, url] = deps;

    var params = url.getQueryParams();
    if (params.via) {
        cookie.set('tap_via', params.via, 30);
    }
})



// WEBPACK FOOTER //
// ./src/Tap/Bundle/SiteBundle/Resources/private/js/pages/tap_publishing_frontend_publisher_register/index.js